// CSS Modules - component class name: NaviSelect__

<template>
  <div
    :class="$style.container"
    @mouseenter="noHover = true"
    @mouseleave="(noHover = false), (open = false)"
    @click="open = true"
  >
    <a
      :class="[
        { NaviSelect__blue: colour === 'blue' },
        { NaviSelect__white: colour === 'white' },
        { NaviSelect__orange: colour === 'orange' },
        { NaviSelect__noHover: noHover },
        { NaviSelect__open: open },
        $style.select
      ]"
    >
      <span>Hydraulikaggregate</span>
      <span :class="$style.triangle"></span>
    </a>
    <ul>
      <li>
        <a href="#">Hydraulikaggregate</a>
      </li>
      <li>
        <a href="#">Schmiersysteme</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NaviSelect",
  props: {
    colour: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      open: false,
      noHover: false
    };
  }
};
</script>

<style module lang="scss">
@import "./NaviSelect.scss";
</style>
